<template lang="pug">
.job-item
  .row
    .col-sm-2
      img.job-logo(
        src='https://thairung.co.th/wp-content/uploads/2020/08/logo.png'
      )

    .col-sm-8
      h4.job-position {{ job.title }}
      ul.job-info
        li
          icon-account
          span {{ job.level }}

        li
          icon-location
          span {{ job.location }}

        li
          icon-bag
          span {{ job.experience }}

    .col-sm-2.text-center
      button.job-like-button
        icon-heart

      .job-post-date
        icon-calendar
        | {{ job.date }}

  .job-readmore(v-if='readmore')
    router-link(:to='`/view/${job.slug}`') อ่านเพิ่มเติม
</template>

<script>
import IconAccount from '../../icons/Account2.vue'
import IconCalendar from '../../icons/Calendar.vue'
import IconBag from '../../icons/Bag.vue'
import IconLocation from '../../icons/Location.vue'
import IconHeart from '../../icons/Heart.vue'

export default {
  components: { IconAccount, IconCalendar, IconBag, IconLocation, IconHeart },
  props: {
    job: {
      type: Object,
      default: () => {},
    },
    readmore: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
